PJQ.constants.projectMessaging = {
	views: {
		GROUPCOMP: 'groupcompany',
		GROUPCOMP_COMP: 'groupcompany-company',
		GROUPCOMP_COMP_CONT: 'groupcompany-company-contact',
		GROUPCONT: 'groupcontact',
		GROUPCONT_CONT: 'groupcontact-contact',
		MSGCONT: 'messagecontact',
		MSGCONT_CONT: 'messagecontact-contact',
		RSPCONT: 'responsecontact',
		RSPCONT_CONT: 'responsecontact-contact',
		COMP: 'company',
		COMP_CONT: 'company-contact',
		CONT: 'contact',
		CONTGROUP: 'contactgroup',
		BIDPKGS: 'bidpackages',
		BIDPKGS_CONT: 'bidpackages-contact'
	}
};
